import { render, staticRenderFns } from "./matchInfo.vue?vue&type=template&id=7fb3f410&scoped=true&lang=pug&"
import script from "./matchInfo.vue?vue&type=script&lang=js&"
export * from "./matchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb3f410",
  null
  
)

export default component.exports